// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../../../public/static/img/rectangle-51.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/static/img/rectangle-5-1x-png.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.the-m-list {
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
}

.the-m-list .div {
  background-color: #ffffff;
  height: 2997px;
  position: relative;
  width: 1280px;
}

.the-m-list .group {
  height: 200px;
  left: 91px;
  object-fit: cover;
  position: absolute;
  top: 2749px;
  width: 1098px;
}

.the-m-list .overlap {
  height: 156px;
  left: 186px;
  position: absolute;
  top: 164px;
  width: 802px;
}

.the-m-list .overlap-group {
  height: 156px;
  left: 0;
  position: absolute;
  top: 0;
  width: 802px;
}

.the-m-list .welcome-to-the-m {
  height: 69px;
  left: 106px;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 696px;
}

.the-m-list .img {
  height: 156px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 156px;
}

.the-m-list .blurb-about-the-list {
  height: 47px;
  left: 206px;
  object-fit: cover;
  position: absolute;
  top: 76px;
  width: 340px;
}

.the-m-list .group-2 {
  height: 69px;
  left: 31px;
  object-fit: cover;
  position: absolute;
  top: 24px;
  width: 1206px;
}

.the-m-list .overlap-2 {
  height: 258px;
  left: 555px;
  position: absolute;
  top: 428px;
  width: 231px;
}

.the-m-list .screenshot {
  height: 228px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 231px;
}

.the-m-list .img-2 {
  height: 81px;
  left: 10px;
  object-fit: cover;
  position: absolute;
  top: 177px;
  width: 212px;
}

.the-m-list .LITTLE-SUNBEAMS {
  height: 17px;
  left: 74px;
  object-fit: cover;
  position: absolute;
  top: 203px;
  width: 84px;
}

.the-m-list .after-school-and {
  height: 12px;
  left: 51px;
  object-fit: cover;
  position: absolute;
  top: 224px;
  width: 138px;
}

.the-m-list .MARIN {
  height: 10px;
  left: 106px;
  object-fit: cover;
  position: absolute;
  top: 191px;
  width: 28px;
}

.the-m-list .overlap-3 {
  height: 258px;
  left: 802px;
  position: absolute;
  top: 428px;
  width: 231px;
}

.the-m-list .DEATH-BY-CHOCOLATE {
  height: 17px;
  left: 64px;
  object-fit: cover;
  position: absolute;
  top: 203px;
  width: 104px;
}

.the-m-list .vegan-delights-for {
  height: 12px;
  left: 52px;
  object-fit: cover;
  position: absolute;
  top: 225px;
  width: 128px;
}

.the-m-list .SAN-FRANCISCO {
  height: 10px;
  left: 84px;
  object-fit: cover;
  position: absolute;
  top: 191px;
  width: 64px;
}

.the-m-list .overlap-4 {
  height: 258px;
  left: 1049px;
  position: absolute;
  top: 428px;
  width: 231px;
}

.the-m-list .rectangle {
  height: 81px;
  left: 6px;
  object-fit: cover;
  position: absolute;
  top: 177px;
  width: 212px;
}

.the-m-list .CONFIDENT-DOLPHINS {
  height: 17px;
  left: 65px;
  object-fit: cover;
  position: absolute;
  top: 203px;
  width: 102px;
}

.the-m-list .private-swimming {
  height: 12px;
  left: 62px;
  object-fit: cover;
  position: absolute;
  top: 225px;
  width: 108px;
}

.the-m-list .BERKELEY {
  height: 10px;
  left: 96px;
  object-fit: cover;
  position: absolute;
  top: 191px;
  width: 41px;
}

.the-m-list .overlap-5 {
  height: 258px;
  left: 308px;
  position: absolute;
  top: 428px;
  width: 231px;
}

.the-m-list .MAYA-DOULA {
  height: 17px;
  left: 84px;
  object-fit: cover;
  position: absolute;
  top: 203px;
  width: 60px;
}

.the-m-list .pre-and-post-natal {
  height: 12px;
  left: 63px;
  object-fit: cover;
  position: absolute;
  top: 224px;
  width: 110px;
}

.the-m-list .SONOMA {
  height: 10px;
  left: 98px;
  object-fit: cover;
  position: absolute;
  top: 191px;
  width: 36px;
}

.the-m-list .featured {
  height: 24px;
  left: 309px;
  object-fit: cover;
  position: absolute;
  top: 395px;
  width: 92px;
}

.the-m-list .overlap-6 {
  height: 258px;
  left: 1049px;
  position: absolute;
  top: 758px;
  width: 231px;
}

.the-m-list .rectangle-2 {
  height: 228px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 6px;
  width: 231px;
}

.the-m-list .coaching {
  height: 24px;
  left: 307px;
  object-fit: cover;
  position: absolute;
  top: 725px;
  width: 95px;
}

.the-m-list .overlap-7 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});

  background-position: 50% 50%;
  background-size: cover;
  height: 790px;
  left: 0;
  position: absolute;
  top: 428px;
  width: 260px;
}

.the-m-list .FILTERS {
  height: 32px;
  left: 32px;
  object-fit: cover;
  position: absolute;
  top: 31px;
  width: 90px;
}

.the-m-list .APPAREL-SHOES-ART {
  height: 477px;
  left: 20px;
  object-fit: cover;
  position: absolute;
  top: 269px;
  width: 186px;
}

.the-m-list .POC-owned-mama-owned {
  height: 114px;
  left: 68px;
  object-fit: cover;
  position: absolute;
  top: 91px;
  width: 118px;
}

.the-m-list .rectangle-3 {
  height: 14px;
  left: 43px;
  object-fit: cover;
  position: absolute;
  top: 97px;
  width: 14px;
}

.the-m-list .rectangle-4 {
  height: 14px;
  left: 43px;
  object-fit: cover;
  position: absolute;
  top: 127px;
  width: 14px;
}

.the-m-list .rectangle-5 {
  height: 14px;
  left: 43px;
  object-fit: cover;
  position: absolute;
  top: 155px;
  width: 14px;
}

.the-m-list .rectangle-6 {
  height: 14px;
  left: 43px;
  object-fit: cover;
  position: absolute;
  top: 184px;
  width: 14px;
}

.the-m-list .rectangle-7 {
  height: 228px;
  left: 555px;
  object-fit: cover;
  position: absolute;
  top: 1100px;
  width: 231px;
}

.the-m-list .rectangle-8 {
  height: 228px;
  left: 802px;
  object-fit: cover;
  position: absolute;
  top: 1100px;
  width: 231px;
}

.the-m-list .rectangle-9 {
  height: 228px;
  left: 1049px;
  object-fit: cover;
  position: absolute;
  top: 1100px;
  width: 231px;
}

.the-m-list .rectangle-10 {
  height: 228px;
  left: 308px;
  object-fit: cover;
  position: absolute;
  top: 1100px;
  width: 231px;
}

.the-m-list .pregnancy-childbirth {
  height: 24px;
  left: 307px;
  object-fit: cover;
  position: absolute;
  top: 1061px;
  width: 238px;
}

.the-m-list .rectangle-11 {
  height: 228px;
  left: 555px;
  object-fit: cover;
  position: absolute;
  top: 1391px;
  width: 231px;
}

.the-m-list .rectangle-12 {
  height: 228px;
  left: 802px;
  object-fit: cover;
  position: absolute;
  top: 1391px;
  width: 231px;
}

.the-m-list .rectangle-13 {
  height: 228px;
  left: 1049px;
  object-fit: cover;
  position: absolute;
  top: 1391px;
  width: 231px;
}

.the-m-list .rectangle-14 {
  height: 228px;
  left: 308px;
  object-fit: cover;
  position: absolute;
  top: 1391px;
  width: 231px;
}

.the-m-list .rectangle-15 {
  height: 228px;
  left: 555px;
  object-fit: cover;
  position: absolute;
  top: 1727px;
  width: 231px;
}

.the-m-list .rectangle-16 {
  height: 228px;
  left: 308px;
  object-fit: cover;
  position: absolute;
  top: 1727px;
  width: 231px;
}

.the-m-list .menopause {
  height: 24px;
  left: 307px;
  object-fit: cover;
  position: absolute;
  top: 1688px;
  width: 111px;
}

.the-m-list .rectangle-17 {
  height: 228px;
  left: 555px;
  object-fit: cover;
  position: absolute;
  top: 2018px;
  width: 231px;
}

.the-m-list .rectangle-18 {
  height: 228px;
  left: 802px;
  object-fit: cover;
  position: absolute;
  top: 2018px;
  width: 231px;
}

.the-m-list .rectangle-19 {
  height: 228px;
  left: 1049px;
  object-fit: cover;
  position: absolute;
  top: 2018px;
  width: 231px;
}

.the-m-list .rectangle-20 {
  height: 228px;
  left: 308px;
  object-fit: cover;
  position: absolute;
  top: 2018px;
  width: 231px;
}

.the-m-list .rectangle-21 {
  height: 228px;
  left: 555px;
  object-fit: cover;
  position: absolute;
  top: 2354px;
  width: 231px;
}

.the-m-list .rectangle-22 {
  height: 228px;
  left: 802px;
  object-fit: cover;
  position: absolute;
  top: 2354px;
  width: 231px;
}

.the-m-list .rectangle-23 {
  height: 228px;
  left: 1049px;
  object-fit: cover;
  position: absolute;
  top: 2354px;
  width: 231px;
}

.the-m-list .rectangle-24 {
  height: 228px;
  left: 308px;
  object-fit: cover;
  position: absolute;
  top: 2354px;
  width: 231px;
}

.the-m-list .EDUCATION {
  height: 24px;
  left: 307px;
  object-fit: cover;
  position: absolute;
  top: 2315px;
  width: 103px;
}

.the-m-list .WHITE-BUTTON {
  height: 42px;
  left: 565px;
  object-fit: cover;
  position: absolute;
  top: 2642px;
  width: 150px;
}

.the-m-list .mamas-recommend-a {
  height: 94px;
  left: 876px;
  object-fit: cover;
  position: absolute;
  top: 1738px;
  width: 340px;
}

.the-m-list .overlap-8 {
  height: 258px;
  left: 555px;
  position: absolute;
  top: 758px;
  width: 231px;
}

.the-m-list .overlap-group-2 {
  height: 258px;
  left: 802px;
  position: absolute;
  top: 758px;
  width: 231px;
}

.the-m-list .overlap-9 {
  height: 258px;
  left: 308px;
  position: absolute;
  top: 758px;
  width: 231px;
}

.the-m-list .are-you-a-business {
  height: 167px;
  left: 42px;
  object-fit: cover;
  position: absolute;
  top: 1272px;
  width: 222px;
}

.the-m-list .CONTACT-wrapper {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: 50% 50%;
  background-size: cover;
  height: 42px;
  left: 42px;
  position: absolute;
  top: 1449px;
  width: 131px;
}

.the-m-list .CONTACT {
  height: 36px;
  left: 24px;
  object-fit: cover;
  position: absolute;
  top: 2px;
  width: 85px;
}

.the-m-list .rectangle-25 {
  height: 79px;
  left: 876px;
  object-fit: cover;
  position: absolute;
  top: 1841px;
  width: 316px;
}

.the-m-list .overlap-10 {
  height: 31px;
  left: 1108px;
  position: absolute;
  top: 1929px;
  width: 96px;
}

.the-m-list .rectangle-26 {
  height: 31px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 76px;
}

.the-m-list .SEND {
  height: 28px;
  left: 17px;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 79px;
}
`, "",{"version":3,"sources":["webpack://./src/components/TheMList/style.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,aAAa;EACb,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,yDAAoE;;EAEpE,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yDAAwE;EACxE,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb","sourcesContent":[".the-m-list {\n  background-color: #ffffff;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n}\n\n.the-m-list .div {\n  background-color: #ffffff;\n  height: 2997px;\n  position: relative;\n  width: 1280px;\n}\n\n.the-m-list .group {\n  height: 200px;\n  left: 91px;\n  object-fit: cover;\n  position: absolute;\n  top: 2749px;\n  width: 1098px;\n}\n\n.the-m-list .overlap {\n  height: 156px;\n  left: 186px;\n  position: absolute;\n  top: 164px;\n  width: 802px;\n}\n\n.the-m-list .overlap-group {\n  height: 156px;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 802px;\n}\n\n.the-m-list .welcome-to-the-m {\n  height: 69px;\n  left: 106px;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  width: 696px;\n}\n\n.the-m-list .img {\n  height: 156px;\n  left: 0;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  width: 156px;\n}\n\n.the-m-list .blurb-about-the-list {\n  height: 47px;\n  left: 206px;\n  object-fit: cover;\n  position: absolute;\n  top: 76px;\n  width: 340px;\n}\n\n.the-m-list .group-2 {\n  height: 69px;\n  left: 31px;\n  object-fit: cover;\n  position: absolute;\n  top: 24px;\n  width: 1206px;\n}\n\n.the-m-list .overlap-2 {\n  height: 258px;\n  left: 555px;\n  position: absolute;\n  top: 428px;\n  width: 231px;\n}\n\n.the-m-list .screenshot {\n  height: 228px;\n  left: 0;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  width: 231px;\n}\n\n.the-m-list .img-2 {\n  height: 81px;\n  left: 10px;\n  object-fit: cover;\n  position: absolute;\n  top: 177px;\n  width: 212px;\n}\n\n.the-m-list .LITTLE-SUNBEAMS {\n  height: 17px;\n  left: 74px;\n  object-fit: cover;\n  position: absolute;\n  top: 203px;\n  width: 84px;\n}\n\n.the-m-list .after-school-and {\n  height: 12px;\n  left: 51px;\n  object-fit: cover;\n  position: absolute;\n  top: 224px;\n  width: 138px;\n}\n\n.the-m-list .MARIN {\n  height: 10px;\n  left: 106px;\n  object-fit: cover;\n  position: absolute;\n  top: 191px;\n  width: 28px;\n}\n\n.the-m-list .overlap-3 {\n  height: 258px;\n  left: 802px;\n  position: absolute;\n  top: 428px;\n  width: 231px;\n}\n\n.the-m-list .DEATH-BY-CHOCOLATE {\n  height: 17px;\n  left: 64px;\n  object-fit: cover;\n  position: absolute;\n  top: 203px;\n  width: 104px;\n}\n\n.the-m-list .vegan-delights-for {\n  height: 12px;\n  left: 52px;\n  object-fit: cover;\n  position: absolute;\n  top: 225px;\n  width: 128px;\n}\n\n.the-m-list .SAN-FRANCISCO {\n  height: 10px;\n  left: 84px;\n  object-fit: cover;\n  position: absolute;\n  top: 191px;\n  width: 64px;\n}\n\n.the-m-list .overlap-4 {\n  height: 258px;\n  left: 1049px;\n  position: absolute;\n  top: 428px;\n  width: 231px;\n}\n\n.the-m-list .rectangle {\n  height: 81px;\n  left: 6px;\n  object-fit: cover;\n  position: absolute;\n  top: 177px;\n  width: 212px;\n}\n\n.the-m-list .CONFIDENT-DOLPHINS {\n  height: 17px;\n  left: 65px;\n  object-fit: cover;\n  position: absolute;\n  top: 203px;\n  width: 102px;\n}\n\n.the-m-list .private-swimming {\n  height: 12px;\n  left: 62px;\n  object-fit: cover;\n  position: absolute;\n  top: 225px;\n  width: 108px;\n}\n\n.the-m-list .BERKELEY {\n  height: 10px;\n  left: 96px;\n  object-fit: cover;\n  position: absolute;\n  top: 191px;\n  width: 41px;\n}\n\n.the-m-list .overlap-5 {\n  height: 258px;\n  left: 308px;\n  position: absolute;\n  top: 428px;\n  width: 231px;\n}\n\n.the-m-list .MAYA-DOULA {\n  height: 17px;\n  left: 84px;\n  object-fit: cover;\n  position: absolute;\n  top: 203px;\n  width: 60px;\n}\n\n.the-m-list .pre-and-post-natal {\n  height: 12px;\n  left: 63px;\n  object-fit: cover;\n  position: absolute;\n  top: 224px;\n  width: 110px;\n}\n\n.the-m-list .SONOMA {\n  height: 10px;\n  left: 98px;\n  object-fit: cover;\n  position: absolute;\n  top: 191px;\n  width: 36px;\n}\n\n.the-m-list .featured {\n  height: 24px;\n  left: 309px;\n  object-fit: cover;\n  position: absolute;\n  top: 395px;\n  width: 92px;\n}\n\n.the-m-list .overlap-6 {\n  height: 258px;\n  left: 1049px;\n  position: absolute;\n  top: 758px;\n  width: 231px;\n}\n\n.the-m-list .rectangle-2 {\n  height: 228px;\n  left: 0;\n  object-fit: cover;\n  position: absolute;\n  top: 6px;\n  width: 231px;\n}\n\n.the-m-list .coaching {\n  height: 24px;\n  left: 307px;\n  object-fit: cover;\n  position: absolute;\n  top: 725px;\n  width: 95px;\n}\n\n.the-m-list .overlap-7 {\n  background-image: url(./../../../public/static/img/rectangle-51.png);\n\n  background-position: 50% 50%;\n  background-size: cover;\n  height: 790px;\n  left: 0;\n  position: absolute;\n  top: 428px;\n  width: 260px;\n}\n\n.the-m-list .FILTERS {\n  height: 32px;\n  left: 32px;\n  object-fit: cover;\n  position: absolute;\n  top: 31px;\n  width: 90px;\n}\n\n.the-m-list .APPAREL-SHOES-ART {\n  height: 477px;\n  left: 20px;\n  object-fit: cover;\n  position: absolute;\n  top: 269px;\n  width: 186px;\n}\n\n.the-m-list .POC-owned-mama-owned {\n  height: 114px;\n  left: 68px;\n  object-fit: cover;\n  position: absolute;\n  top: 91px;\n  width: 118px;\n}\n\n.the-m-list .rectangle-3 {\n  height: 14px;\n  left: 43px;\n  object-fit: cover;\n  position: absolute;\n  top: 97px;\n  width: 14px;\n}\n\n.the-m-list .rectangle-4 {\n  height: 14px;\n  left: 43px;\n  object-fit: cover;\n  position: absolute;\n  top: 127px;\n  width: 14px;\n}\n\n.the-m-list .rectangle-5 {\n  height: 14px;\n  left: 43px;\n  object-fit: cover;\n  position: absolute;\n  top: 155px;\n  width: 14px;\n}\n\n.the-m-list .rectangle-6 {\n  height: 14px;\n  left: 43px;\n  object-fit: cover;\n  position: absolute;\n  top: 184px;\n  width: 14px;\n}\n\n.the-m-list .rectangle-7 {\n  height: 228px;\n  left: 555px;\n  object-fit: cover;\n  position: absolute;\n  top: 1100px;\n  width: 231px;\n}\n\n.the-m-list .rectangle-8 {\n  height: 228px;\n  left: 802px;\n  object-fit: cover;\n  position: absolute;\n  top: 1100px;\n  width: 231px;\n}\n\n.the-m-list .rectangle-9 {\n  height: 228px;\n  left: 1049px;\n  object-fit: cover;\n  position: absolute;\n  top: 1100px;\n  width: 231px;\n}\n\n.the-m-list .rectangle-10 {\n  height: 228px;\n  left: 308px;\n  object-fit: cover;\n  position: absolute;\n  top: 1100px;\n  width: 231px;\n}\n\n.the-m-list .pregnancy-childbirth {\n  height: 24px;\n  left: 307px;\n  object-fit: cover;\n  position: absolute;\n  top: 1061px;\n  width: 238px;\n}\n\n.the-m-list .rectangle-11 {\n  height: 228px;\n  left: 555px;\n  object-fit: cover;\n  position: absolute;\n  top: 1391px;\n  width: 231px;\n}\n\n.the-m-list .rectangle-12 {\n  height: 228px;\n  left: 802px;\n  object-fit: cover;\n  position: absolute;\n  top: 1391px;\n  width: 231px;\n}\n\n.the-m-list .rectangle-13 {\n  height: 228px;\n  left: 1049px;\n  object-fit: cover;\n  position: absolute;\n  top: 1391px;\n  width: 231px;\n}\n\n.the-m-list .rectangle-14 {\n  height: 228px;\n  left: 308px;\n  object-fit: cover;\n  position: absolute;\n  top: 1391px;\n  width: 231px;\n}\n\n.the-m-list .rectangle-15 {\n  height: 228px;\n  left: 555px;\n  object-fit: cover;\n  position: absolute;\n  top: 1727px;\n  width: 231px;\n}\n\n.the-m-list .rectangle-16 {\n  height: 228px;\n  left: 308px;\n  object-fit: cover;\n  position: absolute;\n  top: 1727px;\n  width: 231px;\n}\n\n.the-m-list .menopause {\n  height: 24px;\n  left: 307px;\n  object-fit: cover;\n  position: absolute;\n  top: 1688px;\n  width: 111px;\n}\n\n.the-m-list .rectangle-17 {\n  height: 228px;\n  left: 555px;\n  object-fit: cover;\n  position: absolute;\n  top: 2018px;\n  width: 231px;\n}\n\n.the-m-list .rectangle-18 {\n  height: 228px;\n  left: 802px;\n  object-fit: cover;\n  position: absolute;\n  top: 2018px;\n  width: 231px;\n}\n\n.the-m-list .rectangle-19 {\n  height: 228px;\n  left: 1049px;\n  object-fit: cover;\n  position: absolute;\n  top: 2018px;\n  width: 231px;\n}\n\n.the-m-list .rectangle-20 {\n  height: 228px;\n  left: 308px;\n  object-fit: cover;\n  position: absolute;\n  top: 2018px;\n  width: 231px;\n}\n\n.the-m-list .rectangle-21 {\n  height: 228px;\n  left: 555px;\n  object-fit: cover;\n  position: absolute;\n  top: 2354px;\n  width: 231px;\n}\n\n.the-m-list .rectangle-22 {\n  height: 228px;\n  left: 802px;\n  object-fit: cover;\n  position: absolute;\n  top: 2354px;\n  width: 231px;\n}\n\n.the-m-list .rectangle-23 {\n  height: 228px;\n  left: 1049px;\n  object-fit: cover;\n  position: absolute;\n  top: 2354px;\n  width: 231px;\n}\n\n.the-m-list .rectangle-24 {\n  height: 228px;\n  left: 308px;\n  object-fit: cover;\n  position: absolute;\n  top: 2354px;\n  width: 231px;\n}\n\n.the-m-list .EDUCATION {\n  height: 24px;\n  left: 307px;\n  object-fit: cover;\n  position: absolute;\n  top: 2315px;\n  width: 103px;\n}\n\n.the-m-list .WHITE-BUTTON {\n  height: 42px;\n  left: 565px;\n  object-fit: cover;\n  position: absolute;\n  top: 2642px;\n  width: 150px;\n}\n\n.the-m-list .mamas-recommend-a {\n  height: 94px;\n  left: 876px;\n  object-fit: cover;\n  position: absolute;\n  top: 1738px;\n  width: 340px;\n}\n\n.the-m-list .overlap-8 {\n  height: 258px;\n  left: 555px;\n  position: absolute;\n  top: 758px;\n  width: 231px;\n}\n\n.the-m-list .overlap-group-2 {\n  height: 258px;\n  left: 802px;\n  position: absolute;\n  top: 758px;\n  width: 231px;\n}\n\n.the-m-list .overlap-9 {\n  height: 258px;\n  left: 308px;\n  position: absolute;\n  top: 758px;\n  width: 231px;\n}\n\n.the-m-list .are-you-a-business {\n  height: 167px;\n  left: 42px;\n  object-fit: cover;\n  position: absolute;\n  top: 1272px;\n  width: 222px;\n}\n\n.the-m-list .CONTACT-wrapper {\n  background-image: url(../../../public/static/img/rectangle-5-1x-png.png);\n  background-position: 50% 50%;\n  background-size: cover;\n  height: 42px;\n  left: 42px;\n  position: absolute;\n  top: 1449px;\n  width: 131px;\n}\n\n.the-m-list .CONTACT {\n  height: 36px;\n  left: 24px;\n  object-fit: cover;\n  position: absolute;\n  top: 2px;\n  width: 85px;\n}\n\n.the-m-list .rectangle-25 {\n  height: 79px;\n  left: 876px;\n  object-fit: cover;\n  position: absolute;\n  top: 1841px;\n  width: 316px;\n}\n\n.the-m-list .overlap-10 {\n  height: 31px;\n  left: 1108px;\n  position: absolute;\n  top: 1929px;\n  width: 96px;\n}\n\n.the-m-list .rectangle-26 {\n  height: 31px;\n  left: 0;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  width: 76px;\n}\n\n.the-m-list .SEND {\n  height: 28px;\n  left: 17px;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  width: 79px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
